<template>
  <div class="ContactUs">
    <div>
      <el-image :src="bgImg" fit="cover" />
    </div>
    <div>
      <p>联系方式</p>
      <p>Contact information</p>
      <div><i class="el-icon-phone"></i>0756-8598915</div>
      <div><i class="el-icon-message"></i>zhhaorui@163.com</div>
    </div>
    <div>
      <p>查看路线</p>
      <p>View route</p>
      <div class="amap-wrapper">
        <el-image :src="bgImg2" fit="cover" :preview-src-list="bgList" />
        <!-- <el-amap
          class="amap-box"
          :zoom="zoom"
          :center="center"
          :zoomEnable="zoomEnable"
          :dragEnable="dragEnable"
        >
          <el-amap-marker :position="center" :label="label"></el-amap-marker>
        </el-amap> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      zoom: 15,
      center: [113.542008, 22.234749],
      zoomEnable: false,
      dragEnable: false,
      label: {
        offet: [113.542008, 22.234749],
      },
      bgImg: require("@/assets/ContactUs/bg.png"),
      bgImg2: require("@/assets/ContactUs/bg2.png"),
      bgList: [require("@/assets/ContactUs/bg2.png")],
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>